module.exports = __webpack_public_path__ + "img/视图.05af857b.svg";